require.register("work/controllers/confirmModalCtrl", function(exports, require, module){
  $0
  
});

